import services from '@/http'
//import * as storage from '../storage'
//import * as types from './mutation-types'


export const ActionAddProductToCart = ( context,payload) => {
  return services.product_detail.addProductToCart(payload).then(res => {
    if (res.status == 201) {
      return 'OK'
    }
  })
  .catch(err =>{
    err
    return 'ERROR' 
  })
  
}
